const mutation = {
  // 修改visible 打开弹窗
  changeVisible: (state, str) => {
    state.visible = str
  }
}
export default mutation
